/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    fork, call, takeEvery, put, select,
} from 'redux-saga/effects';

import mbpLogger from 'mbp-logger';

// Operations
import { retrieveCart } from '../Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { checkJWT } from '../../../Checkout/ducks/Global/Global-Operations';
import { updateShowLoadingMessage, flagOffShowLoadingMessage } from '../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import * as addDonationItemActions from './Donation-Actions';
import { prepareRetreiveCart } from '../Cart/ducks/RetrieveCart/PrepareRetreiveCart-Operations';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';
import { processFeatureErrors } from '../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import {
    getOrderId,
} from '../../../Checkout/ducks/Common/Common-Selectors';
import { clearOrderItemErrors } from '../../../Checkout/ducks/Common/ducks/Error/Error-Actions';

// APIs
function* workerAddDonationItem(action) {
    const cartId = yield select(getOrderId);
    try {
        clearOrderItemErrors(
            cartId,
            'donation',
            { errType: '', field: 'error' },
        );

        yield put(updateShowLoadingMessage());
        const jwtToken = yield call(checkJWT);
        const pageProcess = action.data.pageProcess;
        const payload = {
            donationCampaignName: action.data?.title || '',
            productCode: action.data?.sku_code || '',
            customAmount: action.data?.denomination || '',
        };

        yield call(cartServiceClient.donation, {
            jwtToken, payload,
        });
        yield call(prepareRetreiveCart, pageProcess);

        yield call(retrieveCart);
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            function: 'workerCartServiceDonation',
            jsError: ex,
            message: 'Error occured while getting donation Item',
        });
        yield fork(processFeatureErrors, {
            data: {
                orderItemId: cartId,
                errorFeatureType: 'donation',
                errorValues: ex.response?.data,
            },
        });
        yield put(flagOffShowLoadingMessage());
    }
}

function* watchAddDonationItem() {
    yield takeEvery(addDonationItemActions.addDonation().type, workerAddDonationItem);
}

const watchers = [
    fork(watchAddDonationItem),
];

export {
    watchers,
};

export default {};
